import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { cn } from '@hqo/react-hooks';

interface PageHeaderProps {
  title: string
  backTo?: string
  backLabel?: string
  className?: string
}

export const PageHeader = ({ title, backTo, backLabel, className }: PageHeaderProps) => (
  <div className={cn('flex flex-col px-4', className)} data-testid="page-header">
    <div className="flex items-center justify-between">
      {backTo && (
        <Link
          to={backTo}
          className="flex items-center text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          <ChevronLeft className="mr-1 h-4 w-4" />
          {backLabel}
        </Link>
      )}
      {!backTo && <div />}
    </div>

    <h1 className="text-3xl font-medium tracking-tight">{title}</h1>
  </div>
);
